import { useState, useEffect, useContext } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { StorefrontContext } from '../store/StorefrontContext.jsx';
import * as Sentry from '@sentry/react';
import '../scss/banner-carousel.scss'

function BannerCarousel() {
    const { state: storefrontStateObject, fetchMetaObject } = useContext(StorefrontContext);

    // const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log('storefrontStateObject.banner_object updates', storefrontStateObject.banner_object);
        // setLoading(false)
        setError(null)
        // setProducts(storefrontStateObject.products)
    }, [storefrontStateObject]);

    const mediaContentHtml = (banner) => {

        console.log('banner', banner.mediaContentType, banner.url);
        if (banner.active === 'false') {
            return null
        }

        switch (banner.mediaContentType) {
            case 'IMAGE':
                return <img
                    className="d-block w-100 banner-content"
                    src={banner.url}
                    alt={banner?.alt}
                />
            case 'VIDEO':
                return <video
                    className="d-block w-100"
                    src={banner.url}
                    alt={banner?.alt}
                />
            // default:
            //     return <img
            //         className="d-block w-100"
            //         src={banner.url}
            //         alt={banner?.alt}
            //     />
        }

    }
    return (
        !storefrontStateObject?.banner_object ?
            <></>
            :
            <Carousel
                className="banner-carousel"
            >
                {
                    storefrontStateObject.banner_object.map((banner, index) => {
                        return (
                            <Carousel.Item key={index}>
                                {mediaContentHtml(banner)}
                            </Carousel.Item>
                        );
                    })
                }
                {/* <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="https://via.placeholder.com/800x400?text=First+Slide"
                        alt="First slide"
                    />
                    <Carousel.Caption>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="https://via.placeholder.com/800x400?text=Second+Slide"
                        alt="Second slide"
                    />
                    <Carousel.Caption>
                        <h3>Second slide label</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="https://via.placeholder.com/800x400?text=Third+Slide"
                        alt="Third slide"
                    />
                    <Carousel.Caption>
                        <h3>Third slide label</h3>
                        <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
                    </Carousel.Caption>
                </Carousel.Item> */}
            </Carousel>
    );
}

export default Sentry.withProfiler(BannerCarousel);